module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Mono-Bold.beb39f1.woff";